module.exports = __webpack_public_path__ + "static/media/mobile-phones-new.8898cb5d.png";